var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var select = function (value, data) {
  return {}.hasOwnProperty.call(data, value) ? data[value] : data.other;
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};
var fmt = {
  lowercase: v => v.toLowerCase()
};

module.exports = {
  metaData: {
    "default": {
      title: function(d) { return "계정 관리 | The Outnet"; },
      description: function(d) { return "350여 개 이상의 디자이너 브랜드 최대 70% 할인!"; },
      keywords: function(d) { return "남성 디자이너 패션, 남성 디자이너 의류, 남성 디자이너 옷, 남성 디자이너 슈즈, 남성 디자이너 액세서리, 남성 디자이너 백, 미스터포터"; }
    }
  },
  languages: {
    en: function(d) { return "영어"; },
    ar: function(d) { return "اللغة العربية"; },
    de: function(d) { return "Deutsche"; },
    fr: function(d) { return "Française"; },
    ja: function(d) { return "일본어"; },
    ko: function(d) { return "한국어"; }
  },
  titles: {
    mr: function(d) { return "Mr"; },
    ms: function(d) { return "Ms"; },
    mrs: function(d) { return "Mrs"; },
    miss: function(d) { return "Miss"; },
    sir: function(d) { return "Sir"; },
    dr: function(d) { return "Dr"; },
    lord: function(d) { return "Lord"; },
    prof: function(d) { return "Prof"; },
    rev: function(d) { return "Rev"; },
    other: function(d) { return "기타"; }
  },
  menu: function(d) { return "메뉴"; },
  pages: {
    myAccountLanding: {
      title: function(d) { return "내 계정"; },
      description: function(d) { return ""; }
    },
    marketingPreferences: {
      title: function(d) { return "마케팅 설정"; },
      description: function(d) { return "이메일 뉴스레터 선호 사항 설정 및 변경"; }
    },
    myorders: {
      title: function(d) { return "주문"; },
      description: function(d) { return "주문 조회 또는 반품 신청"; }
    },
    savedcards: {
      title: function(d) { return "저장된 카드"; },
      description: function(d) { return "저장된 카드를 확인하고 관리해 보세요"; }
    },
    orderdetails: {
      title: function(d) { return "주문 내역"; },
      description: function(d) { return "주문 내역 보기"; }
    },
    wishlist: {
      title: function(d) { return "위시리스트"; },
      description: function(d) { return "마음에 드는 아이템 저장"; }
    },
    addressBook: {
      title: function(d) { return "주소록"; },
      description: function(d) { return "주소 관리"; }
    },
    accountdetails: {
      title: function(d) { return "내 정보"; },
      description: function(d) { return "로그인 정보 변경"; }
    },
    accountDetailsForm: {
      title: function(d) { return "내 정보 양식"; },
      description: function(d) { return "내 정보 업데이트 양식"; }
    },
    privacy: {
      title: function(d) { return "개인정보 설정"; },
      description: function(d) { return "개인정보 설정 확인 및 관리"; }
    },
    managecards: {
      title: function(d) { return "카드 관리"; },
      description: function(d) { return "저장된 결제 정보를 확인하고 관리해 보세요"; }
    },
    orderdetailsReturn: {
      title: function(d) { return "아이템 반품"; },
      description: function(d) { return ""; }
    },
    guestorderdetails: {
      title: function(d) { return ""; },
      description: function(d) { return ""; }
    },
    referAFriend: {
      title: function(d) { return "친구에게 추천"; },
      description: function(d) { return "친구에게 THE OUTNET을 추천하고 리워드를 받으세요"; }
    },
    credits: {
      title: function(d) { return "스토어 크레딧"; },
      description: function(d) { return "잔액 및 거래 내역 확인"; }
    }
  },
  myAccountLanding: {
    title: function(d) { return "내 계정에 오신 걸 환영합니다"; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다."; },
    retryNow: function(d) { return "지금 다시 시도하세요"; }
  },
  address: {
    primaryInfo: function(d) { return "Default " + select(d.type, { both: "배송지 & 청구지", shipping: "배송지", billing: "청구지", other: "" }) + " address"; }
  },
  addressBook: {
    title: function(d) { return "주소록"; },
    editTitle: function(d) { return "주소 수정하기"; },
    addTitle: function(d) { return "새 주소 추가하기"; },
    "delete": function(d) { return "삭제하기"; },
    undo: function(d) { return "실행 취소하기"; },
    edit: function(d) { return "수정하기"; },
    deleted: function(d) { return "삭제한 주소:"; },
    saved: function(d) { return select(d.type, { update: "주소 수정: " + d.addressLine, other: "새 주소 추가 완료: " + d.addressLine }); },
    description: function(d) { return "주소 관리"; },
    addAddressLink: function(d) { return "주소 추가하기"; },
    deleteError: function(d) { return "주소 삭제 중 문제가 발생했습니다."; },
    emptyAddressesTitle: function(d) { return "저장된 주소가 없습니다."; },
    emptyAddressesDetails: function(d) { return "빠른 결제를 위해 주소를 추가하세요."; },
    emptyAddressLinkTitle: function(d) { return "주소 추가하기"; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다."; },
    retryNow: function(d) { return "지금 다시 시도하세요"; }
  },
  addressForm: {
    save: function(d) { return "저장하기"; },
    select: function(d) { return fmt.lowercase(d.select, "en") + " 선택하기"; },
    display: {
      city: function(d) { return "시·군·구"; },
      country: function(d) { return "국가"; },
      personTitle: function(d) { return "타이틀"; },
      firstName: function(d) { return "이름"; },
      lastName: function(d) { return "성"; },
      addressLine_1: function(d) { return "주소 입력란 1"; },
      addressLine_2: function(d) { return "주소 입력란 2"; },
      cityTownVillage: function(d) { return "동/구/시"; },
      streetName: function(d) { return "도로명 주소"; },
      buildingName: function(d) { return "건물 이름"; },
      district: function(d) { return "읍/면/동"; },
      county: function(d) { return "구/군"; },
      pronunciationFirstName: function(d) { return "이름 발음"; },
      pronunciationLastName: function(d) { return "성 발음"; },
      phone: function(d) { return "전화번호"; },
      alternatePhone: function(d) { return "다른 전화번호"; },
      province: function(d) { return "특별·광역시/도"; },
      state: function(d) { return "주"; },
      region: function(d) { return "지방"; },
      area: function(d) { return "지역"; },
      zipCode: function(d) { return "우편번호"; },
      postCode: function(d) { return "우편번호"; },
      eircode: function(d) { return "Eircode"; },
      pccc: function(d) { return "개인통관고유번호(PCCC)"; },
      taxId: function(d) { return "세금등록번호(Tax ID)"; }
    },
    help: {
      pccc: function(d) { return "개인통관고유번호(PCCC)를 입력해 주세요(예: P + 12자리)"; },
      taxId: function(d) { return "인도네시아 통관을 위해서는 인도네시아 세금등록번호(NPWP)가 필요합니다."; },
      Eircode: function(d) { return "e.g. A65 F4E2"; }
    }
  },
  accountDetails: {
    title: function(d) { return "내 정보"; },
    fullName: function(d) { return d.firstName + " " + d.lastName; },
    description: function(d) { return "로그인 정보 변경"; },
    personalInfo: function(d) { return "개인정보"; },
    email: function(d) { return "이메일 주소"; },
    dob: function(d) { return "생일 " + d.dob; },
    password: function(d) { return "비밀번호"; },
    passwordDots: function(d) { return "●●●●●●●●●●●●"; },
    edit: function(d) { return "수정하기"; },
    cancel: function(d) { return "취소하기"; },
    updated: function(d) { return "고객님의 " + select(d.updateUserSuccess, { personalInfo: "개인 정보", changeEmail: "이메일 주소", changePassword: "비밀번호", other: "정보" }) + "가 업데이트 되었습니다."; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다."; },
    retryNow: function(d) { return "지금 다시 시도하세요."; }
  },
  returnsAndExchangesForm: {
    exchangeLabel: function(d) { return "교환"; },
    returnLabel: function(d) { return "반품"; },
    selectReasonReturn: function(d) { return "사유를 선택해 주세요."; },
    selectReasonExchange: function(d) { return "사유를 선택해 주세요."; },
    reasonLabel: function(d) { return "사유를 알려주세요."; },
    sizesAndColoursTitle: function(d) { return "다른 사이즈를 선택하세요."; },
    colourLabel: function(d) { return "컬러"; },
    sizeLabel: function(d) { return "사이즈"; },
    submit: function(d) { return "계속하기"; },
    other: function(d) { return "기타"; },
    requiredReturnCode: function(d) { return "사유를 선택해 주세요."; },
    requiredReturnNote: function(d) { return "반품 사유는 필수 입력 사항입니다."; },
    requiredSize: function(d) { return "사이즈는 필수 입력 사항입니다."; },
    requiredReturnType: function(d) { return "반품 유형은 필수 입력 사항입니다."; },
    refundLabel: function(d) { return "환불을 원합니다"; }
  },
  refundForm: {
    termsAndConditionsError: function(d) { return "계속하려면 이용약관에 동의해 주세요."; },
    conditionsTitle: function(d) { return "반품 조건"; },
    conditions: function(d) { return "상품은 사용하지 않은 새 상품이어야 하며 태그가 부착된 상태로 반품하셔야 합니다."; },
    termsAndConditions: function(d) { return "THE OUTNET 반품 정책을 읽고 동의합니다."; },
    seeMore: function(d) { return "자세히 보기"; },
    submit: function(d) { return "확인하기"; },
    refundMethodTitle: function(d) { return "선호하는 환불 방법"; },
    refundCard: function(d) { return "신용카드/체크카드로 환불"; },
    refundCardInfo: function(d) { return select(d.showStoreCreditFirst, { true: "결제 서비스 제공 업체에 따라 환불이 귀하의 계정에 표시되기까지 영업일 기준 최대 **10일이** 소요될 수 있습니다", other: "신용카드 및 체크카드로 환불이 이뤄질 예정입니다" }); },
    refundAsCharged: function(d) { return "기존 결제 방법"; },
    refundAsChargedInfo: function(d) { return select(d.showStoreCreditFirst, { true: "결제 서비스 제공 업체에 따라 환불이 귀하의 계정에 표시되기까지 영업일 기준 최대 **10일이** 소요될 수 있습니다", other: "신용카드 및 체크카드로 환불이 이뤄질 예정입니다" }); },
    storeCredit: function(d) { return "스토어 크레딧으로 환불받기"; },
    storeCreditInfo: function(d) { return select(d.showStoreCreditFirst, { true: "반품이 처리된 후 스토어 크레딧으로 환불됩니다.", other: "오늘부터 12개월간 사용 가능" }); },
    storeCreditBanner: function(d) { return "빠른 환불 받기"; }
  },
  colourAndSize: {
    colour: function(d) { return "컬러"; },
    moreColours: function(d) { return "더 많은 컬러"; }
  },
  sizes: {
    sizeLabel: function(d) { return "사이즈"; },
    initialValue: function(d) { return "사이즈를 선택해 주세요"; },
    oneSizeLabel: function(d) { return "한 사이즈만 남았어요"; },
    viewSizeGuide: function(d) { return "사이즈 가이드"; },
    sizeGuide: {
      viewSizeGuide: function(d) { return "사이즈를 찾는 데 도움이 필요하신가요? <u>사이즈 가이드</u>를 확인해 보세요"; },
      title: function(d) { return "사이즈 가이드"; }
    }
  },
  considered: {
    badge: function(d) { return "지속 가능"; }
  },
  changeEmailForm: {
    currentEmail: function(d) { return "현재 이메일 주소"; },
    newEmail: function(d) { return "새로운 이메일 주소"; },
    password: function(d) { return "현재 비밀번호"; },
    update: function(d) { return "업데이트"; }
  },
  changePasswordForm: {
    currentPassword: function(d) { return "현재 비밀번호"; },
    newPassword: function(d) { return "새로운 비밀번호"; },
    confirmPassword: function(d) { return "새로운 비밀번호 확인하기"; },
    update: function(d) { return "비밀번호 업데이트"; },
    passwordRequirements: function(d) { return "최소 8자 이상이어야 하며, 한 개의 대문자 및 숫자가 포함되어야 합니다."; }
  },
  loginAndRegistrationForm: {
    hasAccountTitle: function(d) { return "환영합니다"; },
    hasAccountSubTitle: function(d) { return "이메일 주소를 입력하세요"; },
    noAccountTitle: function(d) { return "회원 가입"; },
    noAccountSubTitle: function(d) { return "계정을 만들어 더 편리하게 쇼핑하세요"; },
    logonId: function(d) { return "이메일 주소"; },
    hasAccount: function(d) { return "기존 회원"; },
    noAccount: function(d) { return "회원 가입"; },
    forgotPassword: function(d) { return ""; },
    forgotPasswordLinkTitle: function(d) { return "비밀번호를 잊어버리셨나요?"; },
    submit: function(d) { return select(d.hasAccount, { true: "로그인", other: "가입하기" }); },
    languageRegistrationPrompt: function(d) { return "다음 항목을 영어로 입력하세요."; }
  },
  loginForm: {
    login: function(d) { return "로그인하기"; },
    logonId: function(d) { return "이메일 주소"; },
    logonPassword: function(d) { return "비밀번호"; }
  },
  loginConsent: {
    title: function(d) { return "사이트에서 변경하기"; },
    overlayBody1: function(d) { return "귀하가 당사 사이트를 마지막으로 방문한 이후 계정 이용약관 및 개인정보보호정책을 업데이트했습니다. 계속하기 전에 아래 내용을 읽고 동의해 주십시오."; },
    overlayBody2: function(d) { return "동의를 클릭하시면 THE OUTNET의 계정 이용약관 및 개인정보보호정책을 읽고 이해한 것으로 간주됩니다."; },
    pleaseNote1: function(d) { return "만약"; },
    dontProceed: function(d) { return "동의하지 않으시는 경우"; },
    pleaseNote2: function(d) { return "가입을 완료할 수 없으며 게스트로 진행하셔야 합니다. 이용약관 및 개인정보보호정책은 게스트로 결제하는 경우에도 적용됩니다."; },
    termsAndConditions: function(d) { return "이용약관"; },
    privacyPolicy: function(d) { return "개인정보 보호정책"; },
    submit: function(d) { return "동의"; },
    and: function(d) { return "및"; }
  },
  registrationForm: {
    register: function(d) { return "가입하기"; },
    logonId: function(d) { return "이메일 주소"; },
    logonPassword: function(d) { return "새 비밀번호 생성"; },
    personTitle: function(d) { return "타이틀"; },
    firstName: function(d) { return "이름"; },
    lastName: function(d) { return "성"; },
    phone1: function(d) { return ""; },
    dateOfBirth: function(d) { return "생년월일(옵션)"; },
    day: function(d) { return "일"; },
    month: function(d) { return "월"; },
    year: function(d) { return "연도"; },
    receiveEmailPreference: function(d) { return "뉴스레터 구독 신청"; },
    maMarketingConsent: function(d) { return "THE OUTNET 뉴스레터를 구독하고 첫 주문 15% 추가 할인 혜택을 받아보세요. 이용 약관 적용"; },
    marketingYes: function(d) { return "예"; },
    marketingNo: function(d) { return "아니요"; },
    selectTitle: function(d) { return "호칭 선택"; },
    other: function(d) { return "기타"; },
    privacyPolicy: function(d) { return ""; },
    privacyPolicyTitle: function(d) { return "개인정보 처리방침"; },
    termsAndConditions: function(d) { return "가입하시면 THE OUTNET의 계정 이용약관을 읽고 이해한 것으로 간주됩니다. "; },
    termsAndConditionsLink: function(d) { return "계정 이용약관"; },
    marketingError: function(d) { return "가입을 완료하려면 옵션을 선택하세요."; },
    autoYesExplanation: function(d) { return "당사의 프로모션 이메일을 수신하지 않으려면 ‘아니요’를 선택하세요."; },
    genderMens: function(d) { return "남성"; },
    genderWomens: function(d) { return "여성"; },
    genderAll: function(d) { return "전체"; },
    emailReadMore: function(d) { return "어떤 소식을 받게 되나요?"; },
    emailInfo: function(d) { return "언제나 스타일리시함을 유지하고 싶으신가요? 프로모션 이메일을 수신하려면 아래에서 선택하세요."; },
    emailInfo1: function(d) { return "내 계정에서 언제든지 이메일 뉴스레터 수신 또는 수신 거부를 설정할 수 있습니다."; },
    emailTitle: function(d) { return "THE OUTNET 이메일"; },
    genderSelectionLabel: function(d) { return "선호 사항을 선택하세요."; },
    gdprConsentTerms: function(d) { return "[계정 이용약관](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)에 동의합니다."; },
    gdprConsentPrivacy: function(d) { return "고객님께서 제공하신 개인 데이터는 당사의 [개인정보보호정책](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/)에 의거하여 계정 등록의 목적으로 처리됩니다."; },
    gdprConsentError: function(d) { return "필수 정보"; },
    checkAll: function(d) { return "모두 확인"; },
    ageConsent: function(d) { return "14세 이상임을 확인합니다(필수)"; },
    tcConsent: function(d) { return "[개인정보 수집 및 이용]() 동의(필수)"; },
    newsletterConsent: function(d) { return "THE OUTNET에서 제공하는 서비스 관련 타겟 마케팅 이니셔티브의 일환으로 신상품 및 익스클루시브 아이템에 대한 정보를 수신하고 연락을 받기 위한 [개인정보 수집 및 이용에]() 대한 동의 (선택)"; },
    termsAndConditionsAcceptance: function(d) { return "가입하시면 THE OUTNET의 계정 이용약관을 읽고 이해한 것으로 간주됩니다. [계정 이용약관](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/) 및 [개인정보 처리방침](https://www.theoutnet.com/" + d.locale + "/page/policies/privacy-policy/) 자세히 보기.\n\n'가입하기'를 클릭하면 본 [이용 약관](https://www.theoutnet.com/" + d.locale + "/page/policies/general-terms-and-conditions-of-sale/#outnet-rewards)에 규정된 대로 당사의 리워드 프로그램에 참여하는 데 동의하는 것이며, [계정 약관](https://www.theoutnet.com/" + d.locale + "/page/policies/account-terms-and-conditions/)에 명시된 추가적인 혜택도 누릴 수 있습니다."; }
  },
  marketingPreferences: {
    title: function(d) { return "마케팅 설정"; },
    description: function(d) { return "이메일 뉴스레터 선호 사항 설정 및 변경"; },
    saveButton: function(d) { return "변경 사항 저장"; },
    error: function(d) { return "선호 사항을 저장하던 중 오류가 발생했습니다."; },
    notification: function(d) { return "선호 사항이 업데이트되었습니다."; },
    emptyLabel: function(d) { return "다음을 선택해 주세요"; },
    preferredCountry: function(d) { return "선호하는 국가"; },
    preferredLanguage: function(d) { return "기본 설정 언어"; },
    preferences: {
      genderMens: function(d) { return "남성"; },
      genderWomens: function(d) { return "여성"; },
      genderAll: function(d) { return "전체"; },
      marketingConsent: {
        title: function(d) { return "마케팅 동의"; },
        description: function(d) { return "최대 75% 할인된 350여 디자이너가 제공하는 최신 트렌드 및 신상품, 전문가의 스타일 조언, 유익한 정보로 가득한 THE OUTNET 이메일을 보내드립니다."; },
        checkboxLabel: function(d) { return "언제나 스타일리시함을 유지하고 싶으신가요? 체크박스를 선택하여 THE OUTNET의 프로모션 이메일을 받아보세요."; }
      },
      CLOTHINGSIZE: {
        title: function(d) { return "의류 사이즈"; },
        description: function(d) { return "다음 중 원하는 사이즈를 선택하세요."; }
      },
      SHOESIZE: {
        title: function(d) { return "슈즈 사이즈"; },
        description: function(d) { return "다음 중 원하는 사이즈를 선택하세요."; },
        sizeSchema: function(d) { return "유럽(EU) 사이즈입니다."; }
      }
    }
  },
  emailPasswordTokenForm: {
    title: function(d) { return "비밀번호 분실"; },
    info: function(d) { return "새 비밀번호를 설정할 수 있는 링크를 이메일로 보내드립니다."; },
    logonId: function(d) { return "이메일 주소"; },
    cancel: function(d) { return "취소"; },
    send: function(d) { return "보내기"; },
    sentEmailSuccess: function(d) { return "제공하신 이메일 주소와 연결된 등록된 계정이 존재하는 경우, 비밀번호 재설정을 위한 링크가 포함된 이메일을 곧 보내드립니다."; },
    backToLogin: function(d) { return "로그인으로 돌아가기"; },
    confirmation: function(d) { return "완료되었습니다."; }
  },
  forgotPassword: {
    cancel: function(d) { return "취소"; }
  },
  resetPasswordForm: {
    title: function(d) { return "새로운 비밀번호"; },
    logonId: function(d) { return "이메일 주소"; },
    createPassword: function(d) { return "새 비밀번호 생성"; },
    confirmPassword: function(d) { return "새로운 비밀번호 확인하기"; },
    submit: function(d) { return "로그인"; },
    resetSuccess: function(d) { return "비밀번호 업데이트가 완료되었습니다. 이제 새 비밀번호로 로그인하실 수 있습니다."; },
    "continue": function(d) { return "로그인 계속하기"; },
    confirmation: function(d) { return "감사합니다!"; }
  },
  orderHistory: {
    title: function(d) { return "주문"; },
    description: function(d) { return "구매한 내용 및 배송 상황을 확인할 수 있습니다."; },
    terms: function(d) { return "구매한 상품이 만족스럽지 않을 경우 주문 상품 수령일로부터 " + d.returnWindow + "일 이내에 당사로 반송하여 환불 또는 교환을 요청하실 수 있습니다."; },
    noOrdersTitle: function(d) { return "주문 내역이 없습니다"; },
    noOrdersDescription: function(d) { return "결제를 완료한 후 여기에서 주문 내용과 배송 상황을 확인할 수 있습니다."; },
    paginationDetails: function(d) { return "총 " + d.totalOrders + "개 주문 중 " + d.totalOrdersDisplayed + "개"; },
    loadMore: function(d) { return "더 보기"; },
    noOrdersLinkTitle: function(d) { return "신상품 쇼핑하기"; },
    errorLoadingMoreOrders: function(d) { return "죄송합니다. 주문 내역을 더 이상 불러올 수 없습니다. 다시 시도해 주세요. "; },
    errorLoadingMorePastOrders: function(d) { return "죄송합니다. 이전 주문 내역을 더 이상 불러올 수 없습니다. "; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다. "; },
    retryButton: function(d) { return "지금 다시 시도하세요."; },
    recentOrders: function(d) { return select(d.error, { false: "최근 주문 (" + d.totalOrders + ")", true: "최근 주문", other: "" }); },
    pastOrders: function(d) { return select(d.error, { false: "이전 주문 (" + d.totalOrders + ")", true: "이전 주문", other: "" }); },
    canBeExchanged: function(d) { return "상품을 교환하거나 환불받으실 수 있어요"; },
    canBeRefunded: function(d) { return "상품을 교환하거나 환불받으실 수 있어요"; },
    cannotBeExchanged: function(d) { return "더 이상 반품할 수 없어요"; },
    cannotBeRefunded: function(d) { return "더 이상 반품할 수 없어요"; },
    customerCare: function(d) { return "고객 서비스 팀"; }
  },
  orderItem: {
    orderId: function(d) { return "주문 " + d.displayId; },
    date: function(d) { return "날짜: " + d.placedDate; },
    price: function(d) { return "총합: " + d.price; },
    viewDetails: function(d) { return "세부 정보 보기"; },
    trackOrder: function(d) { return "주문 조회"; },
    trackExchange: function(d) { return "교환 내역 추적하기"; }
  },
  orderStatus: {
    pending: function(d) { return "처리 중"; },
    cancelled: function(d) { return "취소 완료"; },
    dispatched: function(d) { return "발송 완료"; },
    exchangeReceived: function(d) { return "교환 상품 도착"; },
    exchanged: function(d) { return "교환 완료"; },
    ordered: function(d) { return "주문 완료"; },
    processing: function(d) { return "주문 내역 준비 중"; },
    returnCompleted: function(d) { return "반품 완료"; },
    returnReceived: function(d) { return "반품 상품 도착"; },
    returnRequest: function(d) { return "반품 요청"; },
    returned: function(d) { return "반품 완료"; },
    viewDetails: function(d) { return "세부 정보 보기"; },
    returnRequested: function(d) { return "반품 요청 완료"; },
    returnRefused: function(d) { return "반품 승인되지 않음"; },
    exchangeOrdered: function(d) { return "교환 요청 완료"; },
    exchangeProcessing: function(d) { return "교환 처리 중"; },
    inTransit: function(d) { return "운송 중"; },
    delivered: function(d) { return "배송 완료"; },
    returnProcessing: function(d) { return "반품 검토 중"; },
    returnInTransit: function(d) { return "반품 배송 중"; },
    returnRefunded: function(d) { return "환불 완료"; },
    partiallyReturnRefunded: function(d) { return "일부 환불 완료"; },
    partiallyReturnRefused: function(d) { return "일부 반송 상품 승인되지 않음"; },
    returnAccepted: function(d) { return "반품 승인 완료"; }
  },
  orderItemStatus: {
    RETURN_REQUESTED: function(d) { return "반품 신청"; },
    RETURN_ACCEPTED: function(d) { return "반품 승인 완료"; },
    RETURN_REFUNDED: function(d) { return "환불 완료"; },
    RETURN_REFUSED: function(d) { return "반품 거부"; },
    CANCELLED: function(d) { return "취소 완료"; },
    EXCHANGE_ACCEPTED: function(d) { return "교환 상품 도착"; },
    EXCHANGED: function(d) { return "교환 완료"; }
  },
  orderEvents: {
    TRANSFERRED: function(d) { return "유럽 지점으로부터 상품 배송을 기다리고 있어요"; },
    SCHEDULED: function(d) { return "주문 상품 포장 준비 완료"; },
    RELEASED: function(d) { return "주문 상품이 준비되어 곧 발송 예정"; },
    TRANSIT_001: function(d) { return "배송 중"; },
    TRANSIT_002: function(d) { return "배송 전 주문 상품을 안전하게 보관 중"; },
    TRANSIT_003: function(d) { return "주문 상품이 배송지에 도착하였어요"; },
    EXCEPTION_001: function(d) { return "배송 시도함"; },
    EXCEPTION_002: function(d) { return "세관 지연"; },
    EXCEPTION_003: function(d) { return "배송 지연됨"; },
    EXCEPTION_004: function(d) { return "정확하지 않은 주소. 고객센터에 문의하세요."; },
    EXCEPTION_005: function(d) { return "주문 상품이 반송 중입니다"; },
    EXCEPTION_006: function(d) { return "주문 상품이 반송되었습니다"; },
    EXCEPTION_007: function(d) { return "제공된 주소에 수취인 부재"; },
    EXCEPTION_008: function(d) { return "영업 종료 후 배송이 되었어요"; },
    EXCEPTION_009: function(d) { return "배송 예외 사항으로 인해 소포 배송 실패"; },
    EXCEPTION_010: function(d) { return "고객의 주소 이전으로 인해 소포 배송 실패"; },
    EXCEPTION_011: function(d) { return "수취인이 부득이한 사유로 수령을 거부하여 소포 배송 실패"; },
    EXCEPTION_012: function(d) { return "고객 측의 결제 보류로 인해 소포 배송 보류 중"; },
    EXCEPTION_013: function(d) { return "소포 픽업이 가능한 상황이지만 고객이 미수령"; },
    EXCEPTION_014: function(d) { return "규정을 준수하지 않아 운송업체에서 소포 거부"; },
    EXCEPTION_015: function(d) { return "파손 상태로 발송"; },
    EXCEPTION_016: function(d) { return "소포 분실로 인해 배송 실패"; }
  },
  returnEvents: {
    TRANSIT_001: function(d) { return "반송 상품이 배송 중입니다"; },
    TRANSIT_002: function(d) { return "반송 상품이 로컬 허브 / 분류 시설에 도착하였어요"; },
    TRANSIT_003: function(d) { return "반송 상품이 " + d.country + "에 도착하였어요"; },
    EXCEPTION_001: function(d) { return "반송 상품이 배송되지 않았지만, 곧 재배송 예정입니다"; },
    EXCEPTION_002: function(d) { return "반송 상품의 세관 절차가 지연되고 있어요"; },
    EXCEPTION_003: function(d) { return "반송 상품 배송이 지연되고 있어요"; },
    EXCEPTION_004: function(d) { return "정확하지 않은 주소. 고객센터에 문의하세요."; },
    EXCEPTION_005: function(d) { return "반송 상품이 곧 배송됩니다"; },
    EXCEPTION_006: function(d) { return "반송 상품이 배송되었어요"; },
    EXCEPTION_007: function(d) { return "제공된 주소에 수취인 부재"; },
    EXCEPTION_008: function(d) { return "영업 종료 후 배송이 되었어요"; },
    EXCEPTION_009: function(d) { return "배송 예외 사항으로 인해 소포 배송 실패"; },
    EXCEPTION_010: function(d) { return "고객의 주소 이전으로 인해 소포 배송 실패"; },
    EXCEPTION_011: function(d) { return "수취인이 부득이한 사유로 수령을 거부하여 소포 배송 실패 "; },
    EXCEPTION_012: function(d) { return "고객 측의 결제 보류로 인해 소포 배송 보류 중"; },
    EXCEPTION_013: function(d) { return "소포 픽업이 가능한 상황이지만 고객이 미수령"; },
    EXCEPTION_014: function(d) { return "규정을 준수하지 않아 운송업체에서 소포 거부"; },
    EXCEPTION_015: function(d) { return "파손 상태로 발송"; },
    EXCEPTION_016: function(d) { return "소포 분실로 인해 배송 실패"; },
    RETURN_RECEIVED: function(d) { return "반품 내역이 완료되었어요"; },
    RETURN_ACCEPTED: function(d) { return "반품 내역이 승인되었어요"; },
    PARTIALLY_RETURN_ACCEPTED: function(d) { return "일부 반품 내역이 승인되었어요"; }
  },
  orderStatusDesc: {
    ordered: function(d) { return "곧 주문 상품을 준비할 예정입니다."; },
    processing: function(d) { return "주문 상품을 준비 중이에요"; },
    dispatched: function(d) { return "주문 상품의 배송이 시작되었어요"; },
    inTransit: function(d) { return "주문 상품이 배송 중입니다"; },
    delivered: function(d) { return ""; },
    cancelled: function(d) { return "주문이 취소되었어요. 이 취소 요청을 하지 않았고 추가 정보가 필요하시다면, " + d.phone + " 또는 " + d.mail + " 고객 서비스 팀으로 문의해 주세요"; },
    returnRefused: function(d) { return "죄송합니다. 반품 내역이 승인되지 않았어요. 자세한 정보는 " + d.phone + " 또는 " + d.mail + " 고객 서비스 팀으로 문의해 주세요"; },
    phone: function(d) { return "전화번호"; },
    email: function(d) { return "이메일"; }
  },
  orderDetails: {
    title: function(d) { return "주문 세부 정보"; },
    orderInfo: function(d) { return d.userTitle + " " + d.userLastName + " 주문해 주셔서 감사합니다. 주문 번호: "; },
    orderItemsTitle: function(d) { return "주문 상품"; },
    returnsConditions: function(d) { return "주문 상품이 배송된 날로부터 " + d.returnWindow + "일 이내에 교환 또는 반품을 신청하고 상품을 반송하실 수 있습니다."; },
    quantity: function(d) { return "수량: " + d.quantity; },
    totalsTitle: function(d) { return "주문 요약"; },
    trackOrder: function(d) { return "주문 추적하기"; },
    trackReturn: function(d) { return "반품 추적하기"; },
    trackExchange: function(d) { return "교환 조회"; },
    dateShipped: function(d) { return "고객님의 주문 " + d.displayId + "이/가 " + d.dateShipped + "에 발송되어 배송 중입니다."; },
    timeDelivered: function(d) { return "고객님의 주문은 " + d.timeDelivered + "에 배송되었습니다. 배송일로부터 " + d.returnWindow + "일 이내에 상품을 반품하실 수 있습니다."; },
    timeExchangeDelivered: function(d) { return "고객님의 주문은 " + d.timeDelivered + "에 배송되었습니다. 배송일로부터 " + d.returnWindow + "일 이내에 상품을 교환 또는 반품하실 수 있습니다."; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다."; },
    retryButton: function(d) { return "지금 다시 시도하세요."; },
    createExchange: function(d) { return "교환/반품 신청"; },
    createReturn: function(d) { return "반품 신청"; },
    review: function(d) { return "계속하기"; },
    cancel: function(d) { return "취소하기"; },
    cancelReturn: function(d) { return "반품 취소하기"; },
    reviewChanges: function(d) { return "변경된 사항 확인하기"; },
    edit: function(d) { return "수정하기"; },
    returnStatus: function(d) { return select(d.type, { "return": "반품 요청됨", exchange: "교환 요청됨", other: "" }); },
    returnTitle: function(d) { return "반송 상품"; },
    exchangeTitle: function(d) { return "교환 또는 반품"; },
    exchangeReturn: function(d) { return "교환/반품 신청"; },
    "return": function(d) { return "반품"; },
    confirmReturnTitle: function(d) { return "반품 확인"; },
    confirmMessage: function(d) { return "반품할 상품을 확인해 주시기 바랍니다."; },
    returnConfirmation: function(d) { return d.name + " 님, 요청해 주셔서 감사합니다."; },
    returnConfirmationMessage: function(d) { return d.email + "(으)로 반품 진행에 필요한 모든 정보가 포함된 이메일을 보내드렸습니다."; },
    createStep: function(d) { return "반품 예약하기"; },
    confirmStep: function(d) { return "확인"; },
    collectionStep: function(d) { return "반품"; },
    completeStep: function(d) { return "완료하기"; },
    exit: function(d) { return "이 페이지를 종료하고 요청을 취소하시겠습니까?"; },
    productCode: function(d) { return "상품 코드"; },
    viewMoreDetails: function(d) { return "추가 세부 정보 보기"; },
    customerCare: function(d) { return "상품을 반품 또는 교환할 수 있는 기간이 지났습니다. 도움이 필요하시면 " + d.customerService + "에 문의해 주세요."; },
    customerService: function(d) { return "고객 서비스 팀"; },
    yourExchangesInfo: function(d) { return "교환 번호:"; },
    createdExchangesTitle: function(d) { return "교환을 신청하셨습니다"; },
    createdExchangesInfo: function(d) { return "이 주문에서 하나 이상의 상품에 대해 교환을 신청하셨습니다."; },
    createdReturnsTitle: function(d) { return "반품을 신청하셨습니다"; },
    createdReturnsInfo: function(d) { return "이 주문에서 하나 이상의 상품에 대해 반품을 신청하셨습니다."; },
    finalSale: function(d) { return "파이널 세일. 이 아이템은 반품이 불가합니다."; },
    orderStatus: function(d) { return "주문 상태"; },
    splitShipmentMessage: function(d) { return "다음 상품들은 개별 배송될 수 있습니다"; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "표준 배송", NEXT_DAY_DELIVERY: "익일 배송", PREMIER_DAYTIME: "미스터포터 프리미어 주간 배송", PREMIER_EVENING: "미스터포터 프리미어 야간 배송", EXPRESS: "익스프레스 배송", NOMINATED_DAY: "지정일 배송", other: "" }); },
    delayMessage: function(d) { return select(d.country, { GB: "통관이 원활하게 진행되고 환불이 지연되지 않도록 상품을 반송할 때 주문 상품과 함께 배송된 반품 견적 송장 3부를 작성했는지 확인하시기 바랍니다. 자세한 내용은 [반품 정책](https://www.theoutnet.com/ko-gb/page/help/returns/) 을 참고하세요.", other: "" }); }
  },
  createCollection: {
    bookCollection: function(d) { return "픽업 예약하기"; },
    returnLabelBtn: function(d) { return select(d.hasRequested, { true: "반품 라벨 요청됨", other: "반품 라벨 요청" }); },
    returnLabelInfo: function(d) { return "주문하신 상품 상자 안에 반품 관련 서류가 동봉되어 있습니다. 이 서류를 분실하셨을 경우 [여기](/" + d.locale + "/page/help/contact/) 로 연락주시기 바랍니다. 새 반품 라벨이 필요한 경우 다음을 클릭하세요."; },
    returnLabelSuccess: function(d) { return "반품 라벨이 생성되었습니다. 24시간 이내에 등록하신 이메일로 보내드립니다."; },
    returnLabelError: function(d) { return select(d.error, { ERR_UNABLE_TO_REPRINT_LABEL: "반품 서류는 24시간 이내로 생성이 완료되며 하루에 한 번 신청 가능합니다", ERR_BAD_RESPONSE_FROM_EXTERNAL_SYSTEM: "죄송합니다, 요청하신 페이지에 오류가 발생 하였습니다. 잠시 후 다시 시도해 주시길 바랍니다.", ERR_EXTERNAL_SALESFORCE_SERVICE_UNAVAILABLE: "죄송합니다, 요청하신 페이지에 오류가 발생 하였습니다. 잠시 후 다시 시도해 주시길 바랍니다.", other: "죄송합니다, 요청하신 페이지에 오류가 발생 하였습니다. 고객 서비스로 연락해 주시길 바랍니다." }); },
    title: function(d) { return "주문 상품 반품하기"; },
    subTitle: function(d) { return "반품을 원하시나요?"; },
    optionCollection: function(d) { return "픽업 예약하기"; },
    optionDropOff: function(d) { return "가장 가까운 드롭오프 위치"; },
    submit: function(d) { return "계속하기"; },
    courierTimingMessage: function(d) { return "가장 빠른 픽업 시간:"; },
    courierTimingSelectedMessage: function(d) { return "선택하신 수거 날짜:"; },
    selectDateLabel: function(d) { return "요일 선택하기"; },
    addressMessage: function(d) { return "픽업 장소:"; },
    specialInformationMessage: function(d) { return "요청사항"; },
    boxQuantityMessage: function(d) { return "반품하시려는 박스는 총 몇 개인가요?"; },
    skipReturn: function(d) { return "나중에 반품 예약하기"; },
    returnComplete: function(d) { return "완료되었습니다."; },
    dropOffRequested: function(d) { return "반품 드롭오프를 신청하셨어요"; },
    courierServicePoint: function(d) { return "가장 가까운 서비스 지점 찾기"; },
    returnConfirmationNumber: function(d) { return "반품 확인 번호:"; },
    collectionTime: function(d) { return "다음에 대한 픽업을 요청하셨어요"; },
    parcelQuantity: function(d) { return "박스 개수:"; },
    contactCustomerCare: function(d) { return "다른 주소 또는 다른 시간을 예약하려면, " + d.phone + " 또는 " + d.mail + " 고객 서비스 팀으로 문의해 주세요"; },
    error: function(d) { return select(d.createError, { timeSlotError: "선택하신 시간은 이미 만료되어요. 다른 시간을 선택해 주세요.", other: d.returnCourier + " 서비스와 연락하는 데에 어려움을 겪고 있어요. 대신, 고객 서비스 팀에 연락하고 상품 수거를 요청하거나 배송업체 웹사이트에서 이를 직접 예약하실 수 있습니다" }); },
    maxLength: function(d) { return d.characters + "자 이하여야 합니다."; },
    chooseAnotherDay: function(d) { return "예약이 불가능하다면 다른 날짜를 선택해 보세요"; },
    chosenDayNotAvailable: function(d) { return "선택하신 날짜는 사용이 불가능합니다. 다른 날짜를 선택해 주세요."; },
    timeSlot: {
      now: function(d) { return "지금"; },
      betweenTimeSlot: function(d) { return d.pickupTime + " - " + d.pickupLatest + " 사이"; },
      today: function(d) { return "오늘"; },
      tomorrow: function(d) { return "내일"; },
      monday: function(d) { return "월요일"; },
      tuesday: function(d) { return "화요일"; },
      wednesday: function(d) { return "수요일"; },
      thursday: function(d) { return "목요일"; },
      friday: function(d) { return "금요일"; },
      saturday: function(d) { return "토요일"; },
      sunday: function(d) { return "일요일"; }
    }
  },
  orderTracking: {
    trackDetails: function(d) { return "주문 추적하기"; },
    subTitle: function(d) { return "상품 배송이 시작되는 순간부터 문 앞에 도착할 때까지 상품을 추적해 보세요"; },
    estimatedDeliveryDateInfo: function(d) { return "상품 배송이 시작되면 배송 예정일을 알려드려요"; },
    estimatedDeliveryDateInfoPremier: function(d) { return "상품 배송이 시작되면 전화 또는 이메일로 배송 시간대를 알려드려요"; },
    estimatedDeliveryDate: function(d) { return "배송 예정일:"; },
    deliveredOn: function(d) { return "배송 완료 날짜:"; },
    order: function(d) { return "주문 번호: " + d.orderId; },
    trackingLink: function(d) { return "배송업체 추적하기"; },
    courierTrackingNumber: function(d) { return "배송업체 사이트에서 " + d.trackingNumber + " 추적 번호를 입력하고 상품 배송을 추적해 보세요"; },
    trackingDetails: function(d) { return "배송 추적 정보"; },
    delivered: function(d) { return d.timeDelivered + " 배송됨"; },
    dispatched: function(d) { return d.timeShipped + " 발송됨"; },
    processing: function(d) { return "처리 중"; }
  },
  returnTracking: {
    trackDetails: function(d) { return "반품 추적하기"; },
    subTitle: function(d) { return "반품한 상품의 배송 현황을 조회하세요"; },
    estimatedRefundDateInfo: function(d) { return "반품 요청 후 영업일 3일 이내에 이를 처리하기 위해서 노력하고 있으며, 환불이 진행되면 다시 연락을 드립니다"; },
    trackingLink: function(d) { return "배송업체 추적 확인하기"; },
    returnedToWarehouseOn: function(d) { return "물류창고 도착일:"; },
    partialReturn: function(d) { return "일부 판품 내역이 승인되지 않았어요. 더 자세한 내용은 주문 세부정보를 확인하거나 " + d.phone + " 또는 " + d.mail + " 고객 서비스 팀으로 문의해 주세요"; },
    courierTrackingNumber: function(d) { return "배송업체 사이트에서 " + d.trackingNumber + " 추적 번호를 입력하고 상품 배송을 추적해 보세요"; }
  },
  guestOrderTracking: {
    trackOrder: {
      title: function(d) { return "주문 조회"; },
      info: function(d) { return "아래 입력란에 주문 번호를 입력하시고 주문 내역과 배송 상태를 확인해 보세요."; },
      helpInfo: function(d) { return "방금 주문을 마치셨다면 정보 업데이트에 수 분이 소요됩니다."; },
      error: function(d) { return "죄송합니다. 입력하신 주문 번호와 일치하는 주문 내역을 찾지 못했어요. 다시 시도해 주세요"; },
      lables: {
        email: function(d) { return "이메일 주소"; },
        orderId: function(d) { return "주문 번호"; },
        button: function(d) { return "조회하기"; }
      }
    },
    trackReturn: {
      title: function(d) { return "반품 추적하기"; },
      info: function(d) { return "아래 입력란에 주문 번호를 입력하시고 반품 상태를 확인해 보세요."; },
      helpInfo: function(d) { return "방금 반품을 요청한 경우 업데이트까지 약간의 시간이 소요됩니다."; },
      error: function(d) { return "죄송합니다. 입력하신 주문 번호와 일치하는 반품 내역을 찾지 못했어요. 다시 시도해 주세요"; },
      lables: {
        email: function(d) { return "이메일 주소:"; },
        orderId: function(d) { return "주문 번호:"; },
        button: function(d) { return "추적하기"; }
      }
    },
    createReturn: {
      title: function(d) { return "반품 신청"; },
      info: function(d) { return "주문 상품 수령일로부터 " + d.returnWindow + "일 이내에 반품을 신청하고 당사로 반송하실 수 있습니다. 또한, 고객님의 자택이나 직장, 기타 주소에서 반품할 상품을 수거해 드립니다."; },
      proformaInfo: function(d) { return "통관이 원활하게 진행되도록 상품을 반송할 때 주문 상품과 함께 배송된 반품 견적 송장을 작성했는지 확인하시기 바랍니다. "; },
      helpInfo: function(d) { return "상품은 사용하지 않은 새 상품이어야 하며 모든 THE OUTNET 및 디자이너 태그가 부착된 상태로 반품하셔야 합니다. 자세한 정보는 [당사의 반품 정책을 참고하세요](/" + d.locale + "/page/help/returns/)."; },
      error: function(d) { return "죄송합니다. 입력하신 주문 번호와 일치하는 주문 내역을 찾지 못했어요. 다시 시도해 주세요"; },
      lables: {
        email: function(d) { return "이메일 주소"; },
        orderId: function(d) { return "주문 번호"; },
        button: function(d) { return "반품 시작하기"; }
      },
      notReturnable: function(d) { return "죄송합니다. 이 상품은 반품하실 수 없어요. 더 자세한 내용은 반품 정책을 확인해 주세요. 여기에서 주문을 확인하실 수 있어요:"; }
    }
  },
  unsubscribe: {
    title: function(d) { return "구독 취소"; },
    logonId: function(d) { return "이메일 주소"; },
    submit: function(d) { return "구독 취소"; },
    unsubscribeSuccess: function(d) { return "지금부터 뉴스레터를 보내드리지 않겠습니다."; },
    "continue": function(d) { return "신상품 쇼핑하기"; },
    confirmation: function(d) { return "구독 취소되었습니다!"; }
  },
  price: {
    original: function(d) { return "가격"; },
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    wasPriceOriginal: function(d) { return "RRP: " + d.wasPrice; },
    wasPrice: function(d) { return "RRP:"; },
    originalPrice: function(d) { return "정가:"; },
    discountApplied: function(d) { return "할인 적용:"; },
    itemTax: function(d) { return select(d.included, { true: "포함 ", other: "" }) + "세금: "; },
    tax: function(d) { return "세금: "; },
    duties: function(d) { return select(d.included, { true: "포함 ", other: "" }) + "관세: "; },
    final: function(d) { return "소계"; },
    promoApplied: function(d) { return select(d.description, { undefined: "프로모션", other: d.description }) + " 적용됨"; },
    salesTax: function(d) { return "세금: "; }
  },
  purchasePath: {
    edit: function(d) { return "수정하기"; }
  },
  orderPaymentSummary: {
    shippedTo: function(d) { return "배송지"; },
    shippingMethod: function(d) { return "배송 방법"; },
    billedTo: function(d) { return "청구지 주소"; },
    shippingMethodName: function(d) { return select(d.method, { STANDARD: "스탠다드", EXPRESS: "익스프레스", SATURDAY_DELIVERY: "토요일 배송", NEXT_DAY_DELIVERY: select(d.country, { GB: "익스프레스", other: "익일 배송" }), KIALA_STANDARD: "Kiala", DELIVER_TO_STORE: "매장 배송", PREMIER_DAYTIME: "Premier Daytime", other: "" }); },
    paymentType: function(d) { return select(d.type, { CREDIT_CARD: "신용카드", PAYPAL: "페이팔", PAYPAL_EXPRESS: "페이팔 익스프레스", ALIPAY: "AliPay", PAYEASE: "Pay Ease", PAYEASE_INTERNATIONAL: "Pay Ease Internation", COD: "착불", WIRE_TRANSFER: "송금", SOFORT: "Sofort", STORE_CREDIT: "스토어 크레딧", KLARNA_PAY_NOW: "Pay Now", KLARNA_PAY_LATER: "30일 이내 지불", KLARNA_SLICE_IT: "할부 결제", other: "" }); }
  },
  lineItem: {
    quantity: function(d) { return "수량: "; }
  },
  cardWallet: {
    title: function(d) { return "저장된 카드"; },
    description: function(d) { return "저장된 카드를 확인하고 관리해 보세요"; },
    emptyListTitle: function(d) { return "저장된 카드가 없습니다."; },
    emptyListDetails: function(d) { return "카드를 추가하고 간편한 결제를 이용해 보세요."; },
    addCard: function(d) { return "카드 추가하기"; },
    edit: function(d) { return "수정하기"; },
    "delete": function(d) { return "삭제하기"; },
    cancel: function(d) { return "취소하기"; },
    success: function(d) { return select(d.method, { ADD: "마지막 네 자리" + d.cardLastFour + " 카드가 추가되었습니다.", EDIT: "카드번호 뒷자리 " + d.cardLastFour + " 카드가 등록되었습니다.", DELETE: "마지막 네 자리" + d.cardLastFour + " 카드가 삭제었습니다.", other: "" }); },
    deleteTitle: function(d) { return "카드 삭제하기"; },
    deletePrompt: function(d) { return d.cardNumber + "(으)로 끝나는 이 카드를 삭제하시겠습니까?"; },
    deleteError: function(d) { return "카드번호 뒷자리가 " + d.cardNumber + "인 카드를 삭제하는 도중 오류가 발생하였어요"; },
    pageError: function(d) { return "죄송합니다. 오류가 발생했습니다."; },
    retryButton: function(d) { return "지금 다시 시도하세요."; }
  },
  creditCardForm: {
    title: function(d) { return select(d.method, { ADD: "카드 추가하기", EDIT: "정보 수정하기", other: "" }); },
    number: function(d) { return "카드 번호"; },
    cardHolderName: function(d) { return "카드 소지자 영문 이름"; },
    expiryDate: function(d) { return "만료일"; },
    month: function(d) { return "월"; },
    monthPlaceholder: function(d) { return "MM"; },
    year: function(d) { return "연도"; },
    yearPlaceholder: function(d) { return "YY"; },
    cvv: function(d) { return d.cvvType; },
    cvvHelp: function(d) { return "카드 " + select(d.cvvType, { CID: "앞", other: "뒤" }) + "의 " + plural(d.cvvSize, 0, en, { "0": "보안 코드 ", other: number(d.cvvSize, "cvvSize") + "개 숫자" }); },
    submit: function(d) { return "저장하기"; },
    cardDetails: function(d) { return "카드 세부 정보"; },
    privacyPolicy: function(d) { return "제공된 카드 정보는 오직 결제만을 위해 사용되며 더 자세한 정보는 [개인정보 처리방침](/" + d.locale + "/page/policies/privacy-policy/)에서 확인해 주세요."; },
    acceptedCards: function(d) { return "사용가능한 카드"; },
    error: function(d) { return "문제가 발생하였어요"; }
  },
  card: {
    expiry: function(d) { return "만료"; },
    expired: function(d) { return "만료되었습니다"; },
    cardHolder: function(d) { return "카드 소유자"; }
  },
  customerCare: {
    service: function(d) { return "고객을 위한 서비스"; },
    customerCare: function(d) { return "한국어 고객 서비스"; },
    customerCareDetails: function(d) { return "주문과 관련한 도움부터 사이즈 및 스타일 조언까지, 친절한 상담을 제공합니다."; },
    callUs: function(d) { return "전화 문의"; },
    emailUs: function(d) { return "이메일 문의"; },
    returns: function(d) { return "손쉬운 반품"; },
    returnsDetails: function(d) { return "구매하신 상품이 마음에 들지 않을 경우 간편하게 반품하실 수 있습니다."; },
    returnsLink: function(d) { return "자세히 보기"; },
    delivery: function(d) { return "글로벌 배송"; },
    deliveryDetails: function(d) { return "전 세계 100여 곳으로 배송합니다."; },
    deliveryLink: function(d) { return "배송 옵션 보기"; }
  },
  months: {
    january: function(d) { return "1"; },
    february: function(d) { return "2"; },
    march: function(d) { return "3"; },
    april: function(d) { return "4"; },
    may: function(d) { return "5"; },
    june: function(d) { return "6"; },
    july: function(d) { return "7"; },
    august: function(d) { return "8"; },
    september: function(d) { return "9"; },
    october: function(d) { return "10"; },
    november: function(d) { return "11"; },
    december: function(d) { return "12"; }
  },
  errors: {
    maxLength: function(d) { return select(d.selectMessageField, { zipcodeKR: "5자여야 합니다.", other: d.characters + "자 이하여야 합니다." }); },
    minLength: function(d) { return select(d.selectMessageField, { zipcodeKR: "5자여야 합니다.", other: d.characters + "자 이상이어야 합니다." }); },
    containsWhitespace: function(d) { return "공백 포함"; },
    characterOccurrence: function(d) { return "비밀번호는 " + d.occurrence + "회 이상 사용된 문자를 포함할 수 없습니다."; },
    characterRepeats: function(d) { return "비밀번호에는 동일한 문자를 " + d.repeats + "번 이상 연속해서 사용할 수 없습니다."; },
    containsLogonId: function(d) { return "비밀번호는 로그인 아이디를 포함할 수 없습니다."; },
    containsPassword: function(d) { return "비밀번호는 ‘password’를 포함할 수 없습니다."; },
    invalid: function(d) { return "유효하지 않은 " + d.field + " 입력"; },
    invalidField: function(d) { return "유효하지 않은 문자가 있는지 확인해 주세요"; },
    required: function(d) { return select(d.selectMessageField, { phone1: "문자 메시지를 통해 The Outnet 주문 상품의 배송 상태 업데이트를 받으려면 휴대폰 번호가 필요합니다.", other: select(d.field, { undefined: "필수", other: d.field + " 항목은 필수입니다." }) }); },
    invalidZipCode: function(d) { return select(d.country, { US: "잘못된 우편번호", other: "잘못된 우편번호" }); },
    invalidState: function(d) { return "유효하지 않은 도시"; },
    invalidDob: function(d) { return "(일/월/년) 형식으로 생년월일을 입력해 주세요"; },
    underAge: function(d) { return "만 14세 이상이어야 합니다."; },
    invalidPccc: function(d) { return select(d.field, { TAX_ID: "유효한 세금 ID를 입력해 주세요", PCCC: "PCCC 번호(예: P + 12자리)를 입력해 주세요", other: "유효하지 않은 " + d.name }); },
    generic: function(d) { return "죄송합니다. 오류가 발생했습니다. 나중에 다시 시도하세요."; },
    fieldErrors: function(d) { return "다음 정보를 다시 확인해 주세요:"; },
    global: function(d) { return "문제가 발생했습니다. 나중에 다시 시도하세요."; },
    authenticationError: function(d) { return "로그인에 사용하는 이메일 또는 비밀번호가 올바르지 않습니다."; },
    loginNotAllowed: function(d) { return "다시 로그인하려면 " + d.time + d.timeUnit + "을/를 기다려야 합니다."; },
    timeUnit: function(d) { return select(d.type, { HOUR: "시간", HOURS: "시간", MINUTES: "분", SECONDS: "초", other: "" }); },
    userExists: function(d) { return "이미 존재하는 사용자입니다."; },
    passwordsDontMatch: function(d) { return "비밀번호가 일치하지 않습니다"; },
    phoneRequired: function(d) { return "문자 메시지를 통해 The Outnet 주문 상품의 배송 상태 업데이트를 받으려면 휴대폰 번호가 필요합니다."; },
    mustContainNumber: function(d) { return "비밀번호에는 최소 1개의 숫자가 포함되어야 합니다."; },
    mustContainLetter: function(d) { return "비밀번호에는 최소 " + d.occurrence + "개 문자가 포함되어야 해요"; },
    mustContainUppercase: function(d) { return "비밀번호는 적어도 한 개 이상의 대문자를 포함해야 합니다."; },
    passwordsMatch: function(d) { return "새 비밀번호는 이전 비밀번호와 달라야 합니다."; },
    reuseOldPassword: function(d) { return "이전에 사용했던 비밀번호입니다. 새 비밀번호를 입력하세요."; },
    expiredValidationCode: function(d) { return "죄송합니다. 일회용 코드가 만료되었어요"; },
    invalidValidationCode: function(d) { return "비밀번호 재설정을 다시 시도해 주세요"; },
    blocklistedPassword: function(d) { return "죄송합니다. 해당 비밀번호를 사용할 수 없어요"; },
    updateNotAllowed: function(d) { return "다시 시도하려면 " + d.timeToWait + "시간을 기다려야 합니다."; },
    goBack: function(d) { return "뒤로가기"; },
    pcccRequired: function(d) { return "PCCC 번호(예: P + 12자리)를 입력해 주세요"; },
    swiftCode: function(d) { return "SWIFT 코드는 8-11자 사이여야 해요"; },
    ibanCode: function(d) { return "IBAN 코드는 5-34자 사이로, 영문과 숫자만 사용 가능해요"; },
    returnError: function(d) { return "죄송합니다. 반품 요청을 완료할 수 없어요. 다시 시도하시거나 고객 서비스 팀에 문의해 주세요"; },
    exchangeError: function(d) { return "죄송합니다. 교환 요청을 완료할 수 없어요. 다시 시도하시거나 고객 서비스 팀에 문의해 주세요"; },
    duplicateReturnError: function(d) { return "이 주문에 대한 반품을 이미 요청하셨어요. 내용을 수정하시려면 고객 서비스 팀에 문의해 주세요"; },
    invalidOrderItem: function(d) { return "죄송합니다. 이 상품은 반품하실 수 없어요"; },
    invalidOrder: function(d) { return "죄송합니다. 이 주문은 반품하실 수 없어요"; },
    invalidCharacters: function(d) { return "유효하지 않은 정보입니다"; },
    meetRequirements: function(d) { return "입력한 비밀번호가 위의 요구사항을 충족하는지 확인해 주세요"; },
    zipCodeDoesNotMatchState: function(d) { return d.zip + " 우편번호를 확인해 주세요"; },
    refundPaymentMethod: function(d) { return "반품 환불 방법을 선택해 주세요"; },
    changeCountryNotAllowedError: function(d) { return "이 주문 상품은 다른 국가 또는 지역으로 배송되었어요. 교환 또는 환불을 요청하려면, 주문했던 국가 또는 지역과 일치하도록 수정하고 다시 시도해 주세요"; },
    eircode: function(d) { return "Must be a 7-character alpha-numeric code, e.g. A65 F4E2. For information visit www.eircode.ie"; }
  },
  retry: {
    title: function(d) { return "죄송합니다. 이 페이지를 이용할 수 없습니다."; },
    retrynow: function(d) { return "지금 다시 시도하세요."; },
    timetoretry: function(d) { return d.seconds + "초 후에 다시 연결을 시도합니다."; },
    retryingnow: function(d) { return "지금 다시 시도 중"; }
  },
  totals: {
    itemTotal: function(d) { return "상품 소계"; },
    shipping: function(d) { return "배송"; },
    shippingPrice: function(d) { return select(d.isFree, { true: "무료", other: d.price }); },
    packaging: function(d) { return "포장"; },
    total: function(d) { return "총합"; },
    remove: function(d) { return "삭제하기"; },
    tax: function(d) { return "세금"; },
    duty: function(d) { return "관세"; }
  },
  personalInfoForm: {
    personTitle: function(d) { return "타이틀"; },
    firstName: function(d) { return "이름"; },
    lastName: function(d) { return "성"; },
    dob: function(d) { return "생년월일(옵션)"; },
    submit: function(d) { return "업데이트"; },
    dayPlaceholder: function(d) { return "일"; },
    monthPlaceholder: function(d) { return "월"; },
    yearPlaceholder: function(d) { return "년"; },
    other: function(d) { return "기타"; },
    selectTitle: function(d) { return "호칭 선택"; },
    dobHelp: function(d) { return ""; },
    day: function(d) { return "일"; },
    month: function(d) { return "월"; },
    year: function(d) { return "연도"; }
  },
  greetings: {
    morning: function(d) { return d.firstName + " 님, 좋은 아침입니다"; },
    afternoon: function(d) { return d.firstName + " 님, 즐거운 오후입니다"; },
    evening: function(d) { return d.firstName + " 님, 편안한 저녁입니다"; }
  },
  product: {
    infoUnavailable: function(d) { return "현재 모든 상품 정보를 불러올 수 없습니다. 자세한 내용은 주문 확인 이메일에서 확인하시기 바랍니다."; }
  },
  help: {
    passwordRules: function(d) { return "비밀번호는 8자 이상이어야 하며 대문자와 숫자를 포함해야 합니다."; }
  },
  loginAdditionalMessages: {
    addToWishlist: {
      message: function(d) { return "이 아이템을 위시리스트에 추가하려면 회원 가입하거나 로그인하세요."; }
    },
    restrictedPage: {
      message: function(d) { return "계정에 로그인하여 특별한 혜택을 누리세요."; }
    }
  },
  referrals: {
    title: function(d) { return "친구에게 추천"; },
    landingTitle: function(d) { return "THE OUTNET에 오신 것을 환영합니다!"; },
    error: function(d) { return "죄송합니다. 페이지 로딩 중 오류가 발생했습니다."; },
    errorAction: function(d) { return "뒤로 가기"; },
    cookieMessage: function(d) { return "죄송합니다. 브라우저에서 쿠키를 허용하지 않습니다. 이 페이지를 보시려면 쿠키 차단을 해제하세요."; }
  },
  cod: {
    refund: function(d) { return "이 주문을 착불로 진행하길 요청하셨으므로 환불 절차를 위해 고객님의 은행 세부 정보가 필요합니다."; },
    bankNameFieldName: function(d) { return "은행명"; },
    accountNameFieldName: function(d) { return "예금주"; },
    swiftCodeFieldName: function(d) { return "BIC/SWIFT 코드"; },
    accountNoFieldName: function(d) { return "IBAN 코드"; }
  },
  credits: {
    remainingCredit: function(d) { return "잔여 크레딧:"; },
    transactions: function(d) { return "거래 내역"; },
    error: function(d) { return "죄송합니다. 스토어 크레딧 정보를 찾을 수 없습니다."; },
    title: function(d) { return "스토어 크레딧"; },
    noStoreCredit: function(d) { return "스토어 크레딧이 없습니다."; },
    allTransactions: function(d) { return "모든 거래"; },
    viewAll: function(d) { return "모두 보기"; },
    subheading: function(d) { return "잔액 및 거래 내역을 확인하세요."; },
    closeTransactions: function(d) { return "닫기"; }
  },
  giftcards: {
    title: function(d) { return "기프트 카드"; },
    info: function(d) { return "기프트 카드 사용에 도움이 필요하시면 24시간 언제든지 " + d.countryPhoneLink + "로 전화주세요."; },
    noGiftCard: function(d) { return "기프트 카드가 없습니다."; }
  },
  privacy: {
    version: function(d) { return "버전 " + d.version; },
    read: function(d) { return d.consentTime + "에 확인하셨어요"; },
    pageError: function(d) { return "문제가 발생하였어요. 다시 시도해 주세요"; },
    retryButton: function(d) { return "다시 시도해 주세요"; }
  },
  privacyCloseAccount: {
    title: function(d) { return "계정 삭제하기"; },
    confirmationBody: function(d) { return "계정을 정말 삭제하시겠습니까?"; },
    acknowledgingBodyBp1: function(d) { return "요청을 제출해 주셔서 감사합니다."; },
    acknowledgingBodyBp2: function(d) { return "30일 이내에 계정과 모든 개인정보를 삭제하고 이를 알려드립니다."; },
    confirmButton: function(d) { return "계정 삭제하기"; },
    cancelButton: function(d) { return "취소하기"; }
  },
  tcOverlay: {
    title: function(d) { return "YOOX NET-A-PORTER Group S.p.A. 및 The Net-A-Porter Group Limited는 귀하의 개인정보를 다음과 같이 수집 및 이용합니다."; },
    footer: function(d) { return "For further information, please read our [Privacy Policy](/" + d.locale + "/page/help/privacy-policy/)."; }
  },
  tcParagraphs: {
    pg1: function(d) { return "개인정보의 수집 및 이용 목적: 이용자 식별, 가입 자격 확인, 부정 가입 및 사기 방지, 제품 구매 계약의 실행 및 이행, 웹사이트 및 앱에서 제공하는 서비스 수행, 고객 요청 및 문의에 대한 응답, 법적 청구의 행사 또는 방어, 통계 분석 및 설문, 관련 법률 및 규정에 따른 의무 이행"; },
    pg2: function(d) { return "수집하는 개인정보 항목"; },
    "pg2-1": function(d) { return "[회원가입 시] 이름, 이메일 주소, 비밀번호, 서비스 이용 내역과 이용자 제공 시 생년월일, 성별, 전화번호"; },
    "pg2-2": function(d) { return "[상품 구매 시] 주문 내역, 배송지 주소, 청구서 주소, 전화번호, 결제 정보"; },
    pg3: function(d) { return "개인정보의 보유 및 이용 기간: 회원가입 시 수집된 정보는 탈퇴 요청 시까지 보유 및 이용되며, 상품 구매 계약의 체결 및 이행을 위해 수집된 정보는 관련 조세법령에 따라 모든 행정적, 회계 절차가 종료될 때(10년)까지 저장됩니다."; }
  },
  newsletterTcParagraphs: {
    pg1: function(d) { return "개인정보의 수집 및 이용 목적: 이용자의 쇼핑 경험 향상을 위한 뉴스레터 및 광고, 맞춤형 프로모션 및 마케팅 커뮤니케이션 전송"; },
    pg2: function(d) { return "수집하는 개인정보 항목: 이름, 이메일 주소, 성별, 생년월일, 전화번호, 주문 내역, 브라우징 습관"; },
    pg3: function(d) { return "개인정보의 보유 및 이용 기간: 해당 법률 및 규정에서 허용하는 범위 내에서 개인정보는 귀하가 동의를 철회하거나 회원 탈퇴를 요청한 경우, 또는 커뮤니케이션 사용자 지정과 관련하여 귀하가 쿠키를 비활성화할 때까지 처리됩니다. 해당 법률 및 규정에 의하여 보존해야 하는 기타 정보는 그 법률 및 규정에서 지정한 기간 동안 보존됩니다."; }
  }
}